import React from "react";
import "../Home/Home.css";
import "../../styles/brand.css";
import AboutBanner from "./AboutBanner";
import AboutIntro from "./AboutIntro";
import AboutStory from "./AboutStory";
import AboutVision from "./AboutVision";
import AboutMission from "./AboutMission";
import AboutValues from "./AboutValues";
import AboutExpertise from "./AboutExpertise";
import AboutIndustries from "./AboutIndustries";
import AboutWhyChoose from "./AboutWhyChoose";
import AboutGlobalSupport from "./AboutGlobalSupport";
import AboutFinalCta from "./AboutFinalCta";
import Layout from "../../components/Layout";
import IndustrialCoverage from "./IndustrialCoverage";
import ContactSection4 from "../contact/ContactSection4";
import { aboutSeo } from "./aboutContent";

const SITE_URL = "https://mbasolutions.co";

/* Title and description are the approved document's own SEO Title and Meta
   Description (About Us.docx). The document's slug is /about-us; the live route
   has always been /about, and re-slugging it would break inbound links, the
   sitemap and the header nav — so the canonical stays put. */
const ABOUT_SEO = {
  title: aboutSeo.title,
  description: aboutSeo.description,
  keywords:
    "About MBA Solutions, ISO certification company, management consultancy, compliance consultancy, food safety standards, sustainability frameworks, ESG requirements, supply chain certifications, MBA Solutions team",
  canonical: `${SITE_URL}/about`,
};

const buildAboutJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "About MBA Solutions",
    description: ABOUT_SEO.description,
    url: ABOUT_SEO.canonical,
    mainEntity: {
      "@type": "Organization",
      name: "MBA Solutions",
      url: SITE_URL,
      logo: `${SITE_URL}/assets/Logo.webp`,
      founder: {
        "@type": "Person",
        name: "Muhammad Atif",
        jobTitle: "CEO",
      },
      sameAs: [
        "https://www.facebook.com/MBA.Solutions.Official",
        "https://www.linkedin.com/company/64721224/",
      ],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: SITE_URL,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "About Us",
        item: ABOUT_SEO.canonical,
      },
    ],
  },
];

const About = () => {
  return (
    <Layout
      title={ABOUT_SEO.title}
      description={ABOUT_SEO.description}
      keywords={ABOUT_SEO.keywords}
      canonical={ABOUT_SEO.canonical}
      jsonLd={buildAboutJsonLd()}
    >
      <div className="about-page brand-page bg-gradient-to-b from-[#F8F8F8] via-[#F2F2F2] to-[#ECECEC]">
        {/* banner: the cleaned-up photograph from the supplied About Us
            artwork, with its copy set as HTML (replaces the overview video) */}
        <AboutBanner />

        {/* everything from here to AboutFinalCta is the approved About Us
            document, section for section, in its own order */}
        <AboutIntro />
        <AboutStory />
        <AboutVision />
        <AboutMission />
        <AboutValues />
        <AboutExpertise />
        <AboutIndustries />
        <AboutWhyChoose />
        <AboutGlobalSupport />

        {/* existing page furniture: the industrial coverage grid is live
            first-party navigation. The "Our Amazing Team" block was removed on
            the user's instruction (2026-09-28). */}
        <IndustrialCoverage />

        <AboutFinalCta />
        <div className="pt-8 pb-4">
          <ContactSection4 />
        </div>
      </div>
    </Layout>
  );
};

export default About;
